<template>
  <v-layout row wrap>
    <PowraTitle
      :avatar="'F'"
      :title="
        $vuetify.t('$vuetify.powra.otherControlMeasuresSafetyPrecautionsTaken')
      "
    />

    <v-flex xs12 px-3 class="no-top-border">
      <v-checkbox v-model="adequateControlsToHazards">
        <div slot="label">
          {{ $vuetify.t('$vuetify.powra.adequateControlsToHazards') }}
        </div>
      </v-checkbox>
    </v-flex>
    <v-flex xs12 v-if="adequateControlsToHazards == false">
      <v-card-text class="font-weight-bold">
        {{ $vuetify.t('$vuetify.powra.listAdditionalControlMeasures') }}
      </v-card-text>
    </v-flex>
    <v-flex xs12 px-3 v-if="adequateControlsToHazards == false">
      <v-text-field
        label=""
        outline
        v-model="controlText"
        @blur="newControl(controlText)"
      ></v-text-field>
    </v-flex>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title
          class="headline indigo darken-4 white--text"
          primary-title
        >
          {{ $vuetify.t('$vuetify.dialogs.delete.headline') }}
        </v-card-title>

        <v-card-text>
          C{{ selectedControl }}.
          {{ selectedControl ? controls[selectedControl] : '' }}
        </v-card-text>

        <v-card-text>
          {{ $vuetify.t('$vuetify.dialogs.delete.text') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">
            {{ $vuetify.t('$vuetify.app.cancel') }}
          </v-btn>
          <v-btn
            color="red"
            @click="selectedControl ? deleteControl(selectedControl) : ''"
          >
            {{ $vuetify.t('$vuetify.dialogs.delete.agree') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import PowraTitle from '@/components/powra/PowraTitle.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    PowraTitle
  },
  props: ['controls'],
  data() {
    return {
      dialog: false,
      controlText: null,
      selectedControl: null,
      adequateControlsToHazards: false
    }
  },
  computed: {
    ...mapState({
      // currentRiskAssessment: state => state.calls.currentRiskAssessment,
    }),
    ...mapGetters({
      hasPowra: 'calls/hasPowra',
      currentRiskAssessment: 'calls/currentRiskAssessment'
    })
  },
  methods: {
    newControl(text) {
      if (text) {
        this.$emit('newControl', text)
      }
    },
    populateActivePowraValues() {
      this.controlText = this.currentRiskAssessment.fields.controls
        .other_controls
        ? this.currentRiskAssessment.fields.controls.other_controls.name
        : null
    }
  },
  watch: {
    adequateControlsToHazards: function(newVal, oldVal) {
      this.$emit('adequateControlsToHazards', newVal)
    },
    hasPowra: function() {
      if (this.hasPowra) {
        this.populateActivePowraValues()
      }
    }
  }
}
</script>
